export default __webpack_public_path__ + "static/media/Upload_Cloud_Icon.ba90f8fd.png";